import type { GetStaticProps } from 'next'
import type { FC } from 'react'
import type { Category, Product } from '@/types'

import { Seo } from '@/components/generals/seo'
import { SiteLayout } from '@/components/layout/site-layout'

import {
    GoldCta,
    ProductList,
    ProductsHero,
    SortDropdown
} from '@/components/products'

import { getLayoutData } from '@/lib/layout-data'
import { getProducts } from '@/lib/collections'

interface ProductsProps {
    categories: Category[]
    products: Product[]
}

const DESCRIPTION =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Netus gravida odio sagittis, risus sodales nec. Sagittis nisi at venenatis, pretium. Risus neque a, egestas iaculis.'

const Products: FC<ProductsProps> = ({ categories, products }) => {
    return (
        <SiteLayout categories={categories}>
            <Seo title="Products" description={DESCRIPTION} />

            <div className='section'>
                <div className='container'>
                    <ProductsHero
                        title="PRODUCTS"
                        description={DESCRIPTION}
                        contentId='w-node-_04a49bcf-1cc2-e10a-ec83-4f3503de43c9-c5346dc1'
                    />

                    <SortDropdown categories={categories} label="Sort by" />
                </div>
            </div>

            <ProductList products={products} />

            <GoldCta />
        </SiteLayout>
    )
}

export const getStaticProps: GetStaticProps<ProductsProps> = async () => {
    const { categories } = getLayoutData()
    const products = getProducts()

    return {
        props: {
            categories,
            products
        }
    }
}

export default Products
